import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import WorkHourService from "../Shared/Services/WorkHourService";
import { WorkHour } from "./Models/workHour";

export const ViewWorkHour = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [workHours, setWorkHours] = useState<WorkHour>();

    useEffect(() => {
        getWorkHourById(Number(id));
    }, []);

    const getWorkHourById = (id: number) => {
        WorkHourService.getWorkHourById(id).then((response) => {
            setWorkHours(response.data);
        })
            .catch((error) => {
                console.log(`Error : Something went wrong while getting contracts by id ${id}`, error)
            });
    }
    return (
        <>
            <div className="card card-default" >
                <div className="card-header">
                    <h4>View Work Hours</h4>
                </div>
                <form className="form-control">
                    <div>
                        <div className=" form-group row">
                            <label className="col-sm-3 control-label">
                                <b>Country</b>
                            </label>
                            <div className="col-sm-9">
                                {workHours?.countryName}
                            </div>
                        </div><br />
                        <div className=" form-group row">
                            <label className="col-sm-3 control-label"><b>Role</b></label>
                            <div className="col-sm-9">
                                <div className="d-flex flex-row">
                                    GP
                                </div>
                            </div>
                        </div><br />
                        <div className=" form-group row">
                            <label className="col-sm-3 control-label"><b>Sub Role</b></label>
                            <div className="col-sm-9">
                                <div className="d-flex flex-row">
                                    Salaried GP
                                </div>
                            </div>
                        </div><br />
                        <div className=" form-group row">
                            <label className="col-sm-3 control-label"><b>Contract</b></label>
                            <div className="col-sm-9">
                                <div className="d-flex flex-row">
                                    2020
                                </div>
                            </div>
                        </div><br />
                        <div className=" form-group row">
                            <label className="col-sm-3 control-label">
                                <b> Standard Start Time</b>
                            </label>
                            <div className="col-sm-9">
                                {workHours?.standardStartTime}
                            </div>
                        </div><br />
                        <div className=" form-group row">
                            <label className="col-sm-3 control-label">
                                <b> Standard End Time</b>
                            </label>
                            <div className="col-sm-9">
                                {workHours?.standardEndTime}
                            </div>
                        </div><br />
                        <div className=" form-group row">
                            <label className="col-sm-3 control-label">
                                <b>Premium Start Time</b>
                            </label>
                            <div className="col-sm-9">
                                {workHours?.premiumStartTime}
                            </div>
                        </div><br />
                        <div className=" form-group row">
                            <label className="col-sm-3 control-label">
                                <b> Premium End Time</b>
                            </label>
                            <div className="col-sm-9">
                                {workHours?.premiumEndTime}
                            </div>
                        </div><br />
                        <div className=" form-group row">
                            <label className="col-sm-3 control-label">
                                <b> Normal Session Length</b>
                            </label>
                            <div className="col-sm-9">
                                {workHours?.normalSessionLength}
                            </div>
                        </div><br />
                        <div className=" form-group row">
                            <label className="col-sm-3 control-label">
                                <b>Premium Session Length</b>
                            </label>
                            <div className="col-sm-9">
                                {workHours?.premiumSessionLength}
                            </div>
                        </div><br />
                        <div className="form-group row">
                            <div className=" col-sm-offset-3">
                                <button className="btn btn-secondary" onClick={() => navigate('/workhour')}>Back</button>
                                <button className="btn btn-primary ms-1" type="submit" onClick={() => navigate(`/updateWorkHour/${id}`)}>Edit</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </>
    )
}